<script setup>
defineProps({
  width: {
    type: [String, Number],
    default: 21,
  },
  height: {
    type: [String, Number],
    default: 20,
  },
  stroke: {
    type: String,
    default: '#0E0E22',
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 7.5L10.375 2.5L19.75 7.5L10.375 12.5L1 7.5Z"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.0625 18.75V10L10.375 7.5"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5625 8.66663V12.9261C17.5628 13.0609 17.5192 13.1921 17.4383 13.3C16.912 14.0004 14.6916 16.5625 10.375 16.5625C6.05837 16.5625 3.83798 14.0004 3.31168 13.3C3.23083 13.1921 3.18724 13.0609 3.1875 12.9261V8.66663"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
